// Reveal animations are pure CSS now (see .reveal in styles.css) — no JS
// needed, so content can't get stuck invisible if something else here fails.

// Sticky header state
const header = document.getElementById('siteHeader');
if (header) {
  const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 40);
  document.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
}

// Mobile nav toggle (slide-in drawer)
const navToggle = document.getElementById('navToggle');
if (navToggle) {
  navToggle.addEventListener('click', () => {
    document.body.classList.toggle('nav-open');
  });
}
document.querySelectorAll('.main-nav a').forEach(link => {
  link.addEventListener('click', () => document.body.classList.remove('nav-open'));
});
const navDrawerClose = document.getElementById('navDrawerClose');
if (navDrawerClose) {
  navDrawerClose.addEventListener('click', () => document.body.classList.remove('nav-open'));
}
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && document.body.classList.contains('nav-open')) {
    document.body.classList.remove('nav-open');
  }
});

// If the hero video has no playable source, hide it so the gradient fallback shows
// Desktop-only: on mobile the background video is CSS-hidden and a separate
// .hero-video-mobile element (with native controls) is used instead, so this
// autoplay/unmute logic must not run there — otherwise the hidden desktop
// video can still unmute and play audio on the visitor's first tap.
const heroVideo = document.querySelector('.hero-video');
const isDesktopHero = window.matchMedia('(min-width: 861px)').matches;
if (heroVideo && isDesktopHero) {
  heroVideo.addEventListener('error', () => { heroVideo.style.display = 'none'; }, true);
  if (heroVideo.readyState === 0 && heroVideo.networkState === HTMLMediaElement.NETWORK_NO_SOURCE) {
    heroVideo.style.display = 'none';
  }

  // Browsers only guarantee autoplay when muted, so the video always starts
  // muted, then unmutes itself on the visitor's first interaction with the
  // page (or via the toggle button) — never blocking the autoplay itself.
  const soundToggle = document.getElementById('soundToggle');
  const setToggleLabel = () => {
    if (!soundToggle) return;
    soundToggle.textContent = heroVideo.muted ? '🔇 Tap for Sound' : '🔊 Sound On';
    soundToggle.hidden = false;
  };
  setToggleLabel();

  heroVideo.play().catch(() => {});

  const unmuteOnInteraction = () => {
    heroVideo.muted = false;
    heroVideo.play().catch(() => {});
    setToggleLabel();
    document.removeEventListener('click', unmuteOnInteraction);
    document.removeEventListener('keydown', unmuteOnInteraction);
    document.removeEventListener('touchstart', unmuteOnInteraction);
  };
  document.addEventListener('click', unmuteOnInteraction);
  document.addEventListener('keydown', unmuteOnInteraction);
  document.addEventListener('touchstart', unmuteOnInteraction);

  if (soundToggle) {
    soundToggle.addEventListener('click', (e) => {
      e.stopPropagation();
      heroVideo.muted = !heroVideo.muted;
      if (!heroVideo.muted) heroVideo.play().catch(() => {});
      setToggleLabel();
    });
  }
}

// Newsletter form now posts to Shopify's native customer form (see footer.liquid),
// so no JS submit handler is needed here — the section shows the success/error
// state server-side via form.posted_successfully? / form.errors.

// Gallery: clicking a tile's play button opens its video enlarged in a
// modal instead of playing inline. The tile's own <video> element (already
// rendered by Shopify with the right sources/poster) is relocated into the
// modal on open, and moved back to its original spot on close.
const videoModal = document.getElementById('galleryVideoModal');
const videoModalInner = document.getElementById('galleryVideoModalInner');
const videoModalBackdrop = document.getElementById('galleryVideoModalBackdrop');
const videoModalClose = document.getElementById('galleryVideoModalClose');

if (videoModal && videoModalInner) {
  let activeVideo = null;
  let activeVideoParent = null;
  let heroWasMuted = true;

  const openModalWithVideo = (video) => {
    // Pause (and mute) the hero background video so it doesn't keep playing
    // — silently or otherwise — underneath whatever's being watched in the
    // modal. Its previous muted state is restored when the modal closes.
    if (heroVideo) {
      heroWasMuted = heroVideo.muted;
      heroVideo.muted = true;
      heroVideo.pause();
      const soundToggle = document.getElementById('soundToggle');
      if (soundToggle) soundToggle.textContent = '🔇 Tap for Sound';
    }

    activeVideo = video;
    activeVideoParent = video.parentNode;
    videoModalInner.appendChild(video);
    video.controls = true;
    video.currentTime = 0;
    video.play();
    videoModal.classList.add('is-open');
    document.body.classList.add('video-modal-open');
  };

  const closeModal = () => {
    if (activeVideo) {
      activeVideo.pause();
      activeVideo.controls = false;
      if (activeVideoParent) activeVideoParent.appendChild(activeVideo);
      activeVideo.load();
    }
    videoModal.classList.remove('is-open');
    document.body.classList.remove('video-modal-open');
    activeVideo = null;
    activeVideoParent = null;

    if (heroVideo) {
      heroVideo.muted = heroWasMuted;
      heroVideo.play().catch(() => {});
      const soundToggle = document.getElementById('soundToggle');
      if (soundToggle) soundToggle.textContent = heroVideo.muted ? '🔇 Tap for Sound' : '🔊 Sound On';
    }
  };

  document.querySelectorAll('.gallery-tile-trigger').forEach(button => {
    const tile = button.closest('.gallery-tile');
    const video = tile && tile.querySelector('video');
    if (!video) return;
    button.addEventListener('click', (e) => {
      // Stop this click from bubbling to the document-level listener that
      // unmutes/plays the hero video on first interaction — otherwise it
      // immediately undoes the pause/mute we just did above.
      e.stopPropagation();
      openModalWithVideo(video);
    });
  });

  videoModalClose.addEventListener('click', (e) => {
    e.stopPropagation();
    closeModal();
  });
  videoModalBackdrop.addEventListener('click', (e) => {
    e.stopPropagation();
    closeModal();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && videoModal.classList.contains('is-open')) closeModal();
  });
}

// Contact page: preselect the Interest dropdown when linked with ?interest=sponsor
// (used by the "Become a Sponsor" page CTA) or ?interest=general
const contactInterest = document.getElementById('contactInterest');
if (contactInterest) {
  const interestParam = new URLSearchParams(window.location.search).get('interest');
  if (interestParam) {
    const normalized = interestParam.toLowerCase();
    let match = 'General Inquiry';
    if (normalized.includes('sponsor')) match = 'Sponsorship';
    else if (normalized.includes('challenge')) match = 'Submit Showdem Challenge';
    contactInterest.value = match;
  }
}

// Contact page: only show the Video Link field when Interest is set to
// "Submit Showdem Challenge" — keep it required only while visible so a
// hidden required field can't block submission of other interests
const videoLinkField = document.getElementById('videoLinkField');
if (contactInterest && videoLinkField) {
  const videoLinkInput = videoLinkField.querySelector('input[name="contact[Video Link]"]');
  const updateVideoLinkVisibility = () => {
    const isChallenge = contactInterest.value === 'Submit Showdem Challenge';
    videoLinkField.hidden = !isChallenge;
    if (videoLinkInput) videoLinkInput.required = isChallenge;
  };
  contactInterest.addEventListener('change', updateVideoLinkVisibility);
  updateVideoLinkVisibility();
}

// Event registration page: preselect the Event dropdown when linked with
// ?event=Event+Name (used by the post-checkout redirect script)
const eventField = document.getElementById('eventField');
if (eventField) {
  const eventParam = new URLSearchParams(window.location.search).get('event');
  if (eventParam) {
    const match = Array.from(eventField.options).find(
      opt => opt.value.toLowerCase() === eventParam.toLowerCase()
    );
    eventField.value = match ? match.value : 'Other';
  }
}

// Event registration: Parent/Guardian Consent fields are only required
// when the competitor's entered age is under 18
const competitorAge = document.getElementById('competitorAge');
const guardianFields = document.querySelectorAll('.guardian-field');
if (competitorAge && guardianFields.length) {
  const updateGuardianRequirement = () => {
    const age = parseInt(competitorAge.value, 10);
    const isMinor = !isNaN(age) && age < 18;
    guardianFields.forEach(field => { field.required = isMinor; });
  };
  competitorAge.addEventListener('input', updateGuardianRequirement);
  updateGuardianRequirement();
}

// Cart page: updates quantities via Shopify's Ajax Cart API (not a guessed
// form field name) so the total is always correct. After a successful
// update we reload the page so Shopify's own Liquid rendering formats the
// total/currency correctly — only the total changes, per-item prices are
// fixed unit prices and don't move.
const cartItemsList = document.getElementById('cartItemsList');
if (cartItemsList) {
  const updateBtn = document.getElementById('cartUpdateBtn');
  if (updateBtn) {
    updateBtn.addEventListener('click', () => {
      const updates = {};
      cartItemsList.querySelectorAll('.cart-qty-input').forEach(input => {
        updates[input.dataset.key] = parseInt(input.value, 10) || 0;
      });

      updateBtn.disabled = true;
      updateBtn.textContent = 'Updating…';

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(res => res.json())
        .then(() => {
          window.location.reload();
        })
        .catch(() => {
          updateBtn.disabled = false;
          updateBtn.textContent = 'Update Cart';
        });
    });
  }
}

// Cart page: applying a discount code uses Shopify's native /discount/{code}
// redirect endpoint — it validates the code against your active discounts,
// applies it to the session, and carries it straight into checkout with no
// app required.
const cartDiscountForm = document.getElementById('cartDiscountForm');
if (cartDiscountForm) {
  cartDiscountForm.addEventListener('submit', (e) => {
    e.preventDefault();
    const code = document.getElementById('cartDiscountCode').value.trim();
    if (!code) return;
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
  });
}

// Footer year
const yearEl = document.getElementById('year');
if (yearEl) yearEl.textContent = new Date().getFullYear();

// Cart drawer: clicking the header cart icon opens a slide-in drawer instead
// of navigating to the cart page, using Shopify's Ajax Cart API so quantity
// changes and removals happen live with no page reload. The cart icon keeps
// its real href to /cart as a fallback if JS fails to load.
const cartDrawer = document.getElementById('cartDrawer');
const cartDrawerBackdrop = document.getElementById('cartDrawerBackdrop');
const cartDrawerBody = document.getElementById('cartDrawerBody');
const cartDrawerUpsell = document.getElementById('cartDrawerUpsell');
const cartDrawerTotal = document.getElementById('cartDrawerTotal');
const cartIconLink = document.getElementById('cartIconLink');

const formatMoney = (cents) => '$' + (cents / 100).toFixed(2);

function renderCartDrawer(cart) {
  if (!cartDrawerBody) return;
  if (!cart.items.length) {
    cartDrawerBody.innerHTML = '<p class="cart-drawer-empty">Your cart is empty.</p>';
    if (cartDrawerTotal) cartDrawerTotal.textContent = '';
    return;
  }
  cartDrawerBody.innerHTML = cart.items.map((item) => `
    <div class="cart-drawer-item">
      ${item.image ? `<img src="${item.image}" alt="${(item.product_title || '').replace(/"/g, '&quot;')}">` : ''}
      <div class="cart-drawer-item-info">
        <h4>${item.product_title}</h4>
        <p class="cart-drawer-item-price">${formatMoney(item.final_price)}</p>
        <div class="cart-drawer-qty">
          <button type="button" class="cart-drawer-qty-minus" data-key="${item.key}" data-qty="${item.quantity - 1}" aria-label="Decrease quantity">&minus;</button>
          <span>${item.quantity}</span>
          <button type="button" class="cart-drawer-qty-plus" data-key="${item.key}" data-qty="${item.quantity + 1}" aria-label="Increase quantity">+</button>
        </div>
        <button type="button" class="cart-drawer-remove" data-key="${item.key}">Remove</button>
      </div>
    </div>
  `).join('');
  if (cartDrawerTotal) cartDrawerTotal.textContent = 'Total: ' + formatMoney(cart.total_price);
}

// Cart drawer upsell: the product cards are picked by the merchant (see the
// "Cart upsell product" blocks on the Header section in the Theme
// Customizer) and rendered once by Liquid at page load. This just hides
// whichever ones are already in the cart and shows/hides the whole row.
function updateCartUpsell(cart) {
  if (!cartDrawerUpsell) return;
  if (!cart.items.length) {
    cartDrawerUpsell.hidden = true;
    return;
  }
  const cartProductIds = cart.items.map((item) => item.product_id);
  let visibleCount = 0;
  cartDrawerUpsell.querySelectorAll('.cart-drawer-upsell-item').forEach((item) => {
    const inCart = cartProductIds.includes(parseInt(item.dataset.productId, 10));
    item.hidden = inCart;
    if (!inCart) visibleCount++;
  });
  cartDrawerUpsell.hidden = visibleCount === 0;
}


function updateCartCount(count) {
  const cartIcon = document.querySelector('.cart-icon');
  let cartCountEl = document.querySelector('.cart-count');
  if (count > 0) {
    if (!cartCountEl && cartIcon) {
      cartCountEl = document.createElement('span');
      cartCountEl.className = 'cart-count';
      cartIcon.appendChild(cartCountEl);
    }
    if (cartCountEl) cartCountEl.textContent = count;
  } else if (cartCountEl) {
    cartCountEl.remove();
  }
}

function loadCartDrawer() {
  fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
      renderCartDrawer(cart);
      updateCartCount(cart.item_count);
     updateCartUpsell(cart);
    });
}

function changeCartItem(key, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: quantity })
  })
    .then((res) => res.json())
    .then((cart) => {
      renderCartDrawer(cart);
      updateCartCount(cart.item_count);
     updateCartUpsell(cart);
    });
}

function addUpsellItem(variantId, button) {
  button.disabled = true;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then((res) => res.json())
    .then(() => {
      loadCartDrawer();
    })
    .catch(() => {
      button.disabled = false;
    });
}

function openCartDrawer() {
  if (!cartDrawer) return;
  document.body.classList.add('cart-drawer-open');
  cartDrawer.classList.add('is-open');
  if (cartDrawerBackdrop) cartDrawerBackdrop.classList.add('is-open');
  loadCartDrawer();
}

function closeCartDrawer() {
  if (!cartDrawer) return;
  document.body.classList.remove('cart-drawer-open');
  cartDrawer.classList.remove('is-open');
  if (cartDrawerBackdrop) cartDrawerBackdrop.classList.remove('is-open');
}

if (cartIconLink) {
  cartIconLink.addEventListener('click', (e) => {
    e.preventDefault();
    openCartDrawer();
  });
}
if (cartDrawerBackdrop) {
  cartDrawerBackdrop.addEventListener('click', closeCartDrawer);
}
const cartDrawerClose = document.getElementById('cartDrawerClose');
if (cartDrawerClose) {
  cartDrawerClose.addEventListener('click', closeCartDrawer);
}
if (cartDrawerBody) {
  cartDrawerBody.addEventListener('click', (e) => {
    const key = e.target.dataset.key;
    if (!key) return;
    if (e.target.classList.contains('cart-drawer-qty-minus') || e.target.classList.contains('cart-drawer-qty-plus')) {
      const qty = parseInt(e.target.dataset.qty, 10);
      changeCartItem(key, Math.max(0, qty));
    } else if (e.target.classList.contains('cart-drawer-remove')) {
      changeCartItem(key, 0);
    }
  });
}
if (cartDrawerUpsell) {
  cartDrawerUpsell.addEventListener('click', (e) => {
    const button = e.target.closest('.cart-drawer-upsell-add');
    if (!button) return;
    addUpsellItem(button.dataset.variantId, button);
  });
}
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('is-open')) {
    closeCartDrawer();
  }
});

// Product page: "Add to Cart" adds the item via Shopify's Ajax Cart API and
// opens the cart drawer instead of navigating to a separate page, so
// shoppers stay put and keep browsing. Event registration forms are not
// targeted here (they intentionally go straight to checkout).
document.querySelectorAll('.product-add-form').forEach((form) => {
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    const errorEl = form.querySelector('.form-error');
    const originalText = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding…';
    }
    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
      .then(({ ok, data }) => {
        if (!ok) throw new Error(data.description || data.message || 'Could not add to cart.');
        openCartDrawer();
      })
      .catch((err) => {
        if (errorEl) {
          errorEl.textContent = err.message || 'Could not add to cart.';
          errorEl.hidden = false;
        }
      })
      .finally(() => {
        if (button) {
          button.disabled = false;
          button.textContent = originalText;
        }
      });
  });
});
